import LoaiNganhPage from './LoaiNganhPage';

export default LoaiNganhPage;
